import type { WalletCsvScope } from '../../../../queries/pxtraCard';

/** The proxy drops Content-Disposition, so the client names the file. */
export const csvFilename = (scope: WalletCsvScope) => {
  if ('transactionId' in scope) {
    const id = scope.transactionId.slice(0, 6);
    return scope.date ? `Beleg_${scope.date}_${id}.csv` : `Beleg_${id}.csv`;
  }
  return scope.month === undefined
    ? `Wallet_${scope.year}.csv`
    : `Wallet_${scope.year}-${String(scope.month).padStart(2, '0')}.csv`;
};

/** Identifies one download button, so only the one that was pressed shows as busy. */
export const csvScopeKey = (scope: WalletCsvScope) => {
  if ('transactionId' in scope) return `receipt:${scope.transactionId}`;
  return `${scope.year}:${scope.month ?? 'year'}`;
};
